const SET_QUOTE = 'directOrderRecurring/SET_QUOTE';
const CLEAN_QUOTE = 'directOrderRecurring/CLEAN_QUOTE';

const SET_QUOTE_ERROR = 'directOrderRecurring/SET_QUOTE_ERROR';
const CLEAN_QUOTE_ERROR = 'directOrderRecurring/CLEAN_QUOTE_ERROR';

export default {
  SET_QUOTE,
  CLEAN_QUOTE,

  SET_QUOTE_ERROR,
  CLEAN_QUOTE_ERROR,
};
